import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export function ResetPassword() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const requestCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password/reset-request", { email });
      toast.success("Codice inviato. Controlla la tua email.");
      setStep(2);
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  const confirm = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password/reset-confirm", { token, password });
      toast.success("Password aggiornata. Ora puoi accedere.");
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <div className="px-4 pt-10 sm:pt-16 space-y-8 sm:max-w-md sm:mx-auto" data-testid="reset-password-page">
      <div className="space-y-2">
        <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">Reimposta password</h1>
        <p className="text-base text-slate-600">{step === 1 ? "Ti invieremo un codice via email." : "Inserisci il codice ricevuto e la nuova password."}</p>
      </div>

      {step === 1 ? (
        <form onSubmit={requestCode} className="space-y-4" data-testid="reset-request-form">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="reset-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="h-14 bg-slate-50 border-transparent focus:bg-white focus:border-volt rounded-2xl" placeholder="nome@email.it" />
          </div>
          <Button data-testid="reset-send-btn" type="submit" disabled={loading} className="w-full h-14 rounded-full bg-whoo hover:bg-whoo-dark text-white font-heading font-semibold active:scale-[0.98] transition-transform">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Invia codice"}
          </Button>
        </form>
      ) : (
        <form onSubmit={confirm} className="space-y-4" data-testid="reset-confirm-form">
          <div className="space-y-2">
            <Label htmlFor="token">Codice</Label>
            <Input id="token" data-testid="reset-token-input" required value={token} onChange={(e) => setToken(e.target.value)}
              className="h-14 bg-slate-50 border-transparent focus:bg-white focus:border-volt rounded-2xl" placeholder="Codice ricevuto via email" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="newpass">Nuova password</Label>
            <Input id="newpass" data-testid="reset-newpass-input" type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
              className="h-14 bg-slate-50 border-transparent focus:bg-white focus:border-volt rounded-2xl" placeholder="Minimo 8 caratteri" />
          </div>
          <Button data-testid="reset-confirm-btn" type="submit" disabled={loading} className="w-full h-14 rounded-full bg-whoo hover:bg-whoo-dark text-white font-heading font-semibold active:scale-[0.98] transition-transform">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Conferma nuova password"}
          </Button>
        </form>
      )}

      <p className="text-sm text-center pb-6"><Link to="/login" data-testid="back-login-link" className="text-volt font-semibold">Torna al login</Link></p>
    </div>
  );
}
